export const hotKeyWords = [
  {
    url: 'http://souke.xdf.cn/Category/0-174-743-0.html?v=5&adpl=XDF_daxueN_hotword_1&adct=考研英语',
    title: '考研英语'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-174-745-0.html?v=5&adpl=XDF_daxueN_hotword_2&adct=考研数学',
    title: '考研数学'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-174-744-0.html?v=5&adpl=XDF_daxueN_hotword_3&adct=考研政治',
    title: '考研政治'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-31-0-0.html?v=5&adpl=XDF_daxueN_hotword_4&adct=四级',
    title: '四级'
  },
  {
    url: 'http://souke.xdf.cn/Class/0-1871530.html?adpl=XDF_daxueN_hotword_5&adct=四级基础强化冲刺套餐',
    title: '四级基础强化冲刺套餐'
  },
  {
    url: 'http://souke.xdf.cn/Category/0-63-0-0.html?v=5&adpl=XDF_daxueN_hotword_6&adct=六级',
    title: '六级'
  },
  {
    url: 'http://souke.xdf.cn/Class/0-1871531.html?adpl=XDF_daxueN_hotword_7&adct=六级基础强化冲刺套餐',
    title: '六级基础强化冲刺套餐'
  }
]



// WEBPACK FOOTER //
// ./src/api/js/univercity/hotkeywords.js